// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'
import {Point} from './point.js'
import {SeqId} from './seq-id.js'
import {SetFloat} from './set-float.js'
import {SetSize} from './set-size.js'

export class ModifyPosition {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): ModifyPosition {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  static getRootAsModifyPosition(bb: flatbuffers.ByteBuffer, obj?: ModifyPosition): ModifyPosition {
    return (obj || new ModifyPosition()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  static getSizePrefixedRootAsModifyPosition(bb: flatbuffers.ByteBuffer, obj?: ModifyPosition): ModifyPosition {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH)
    return (obj || new ModifyPosition()).__init(bb.readInt32(bb.position()) + bb.position(), bb)
  }

  target(obj?: Id): Id | null {
    const offset = this.bb!.__offset(this.bb_pos, 4)
    return offset ? (obj || new Id()).__init(this.bb_pos + offset, this.bb!) : null
  }

  page(obj?: SeqId): SeqId | null {
    const offset = this.bb!.__offset(this.bb_pos, 6)
    return offset ? (obj || new SeqId()).__init(this.bb_pos + offset, this.bb!) : null
  }

  origin(obj?: Point): Point | null {
    const offset = this.bb!.__offset(this.bb_pos, 8)
    return offset ? (obj || new Point()).__init(this.bb_pos + offset, this.bb!) : null
  }

  rotation(obj?: SetFloat): SetFloat | null {
    const offset = this.bb!.__offset(this.bb_pos, 10)
    return offset ? (obj || new SetFloat()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  scale(obj?: SetSize): SetSize | null {
    const offset = this.bb!.__offset(this.bb_pos, 12)
    return offset ? (obj || new SetSize()).__init(this.bb!.__indirect(this.bb_pos + offset), this.bb!) : null
  }

  zIndex(): bigint | null {
    const offset = this.bb!.__offset(this.bb_pos, 14)
    return offset ? this.bb!.readUint64(this.bb_pos + offset) : null
  }

  static startModifyPosition(builder: flatbuffers.Builder) {
    builder.startObject(6)
  }

  static addTarget(builder: flatbuffers.Builder, targetOffset: flatbuffers.Offset) {
    builder.addFieldStruct(0, targetOffset, 0)
  }

  static addPage(builder: flatbuffers.Builder, pageOffset: flatbuffers.Offset) {
    builder.addFieldStruct(1, pageOffset, 0)
  }

  static addOrigin(builder: flatbuffers.Builder, originOffset: flatbuffers.Offset) {
    builder.addFieldStruct(2, originOffset, 0)
  }

  static addRotation(builder: flatbuffers.Builder, rotationOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, rotationOffset, 0)
  }

  static addScale(builder: flatbuffers.Builder, scaleOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, scaleOffset, 0)
  }

  static addZIndex(builder: flatbuffers.Builder, zIndex: bigint) {
    builder.addFieldInt64(5, zIndex, null)
  }

  static endModifyPosition(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject()
    builder.requiredField(offset, 4) // target
    return offset
  }
}
